import { useRoutes } from 'react-router-dom';

import { getRouteConfigs } from '../configs/routeConfigs'

export default function Router() {

  let routes;

  routes = getRouteConfigs()

  // console.log('routes', routes)

  return useRoutes(routes)
}
